module.exports = __webpack_public_path__ + "img/IMG_4097.df97992a.jpeg";